import { CREDIT, TELNET, CUSTOMER_MANAGER, SUPPORT } from "@/constants/roles";
import { IApplicationStatus } from "@/store/applications/types";

/**
 * Converts an array of IApplicationStatus to an array of strings.
 * @param {IApplicationStatus[]} statuses - Array of applications to convert.
 */
function toStrings(statuses: IApplicationStatus[]) {
  return statuses.map(e => IApplicationStatus[e]);
}

export const ALL_STATUSES = toStrings([
  IApplicationStatus.Approved,
  IApplicationStatus.AwaitingPersonalGuarantee,
  IApplicationStatus.PersonalGuaranteeFollowUp,
  IApplicationStatus.CallbackRequested,
  IApplicationStatus.Cancelled,
  IApplicationStatus.CardAccountSetupComplete,
  IApplicationStatus.Completed,
  IApplicationStatus.Started,
  IApplicationStatus.Declined,
  IApplicationStatus.Draft,
  IApplicationStatus.Referred
]);

export const CANCELLABLE_STATUSES = toStrings([
  IApplicationStatus.Approved,
  IApplicationStatus.AwaitingPersonalGuarantee,
  IApplicationStatus.PersonalGuaranteeFollowUp,
  IApplicationStatus.CallbackRequested,
  IApplicationStatus.Started,
  IApplicationStatus.Referred
]);

export const EDITABLE_STATUSES = toStrings([
  IApplicationStatus.Approved,
  IApplicationStatus.AwaitingPersonalGuarantee,
  IApplicationStatus.PersonalGuaranteeFollowUp,
  IApplicationStatus.Referred
]);

export const DRAFTS_DEFAULT_STATUSES = toStrings([
  IApplicationStatus.Draft,
  IApplicationStatus.DroppedOut
]);

export const COMPLETED_DEFAULT_STATUSES = toStrings([
  IApplicationStatus.Cancelled,
  IApplicationStatus.Completed,
  IApplicationStatus.Declined
]);

export const MY_APPLICATION_ROLE_STATUSES = {
  [TELNET]: toStrings([
    IApplicationStatus.Approved,
    IApplicationStatus.PersonalGuaranteeFollowUp,
    IApplicationStatus.CardAccountSetupComplete
  ]),
  [CREDIT]: toStrings([
    IApplicationStatus.AwaitingPersonalGuarantee,
    IApplicationStatus.Referred
  ]),
  [CUSTOMER_MANAGER]: toStrings([IApplicationStatus.CallbackRequested]),
  [SUPPORT]: toStrings([
    IApplicationStatus.Approved,
    IApplicationStatus.AwaitingPersonalGuarantee,
    IApplicationStatus.PersonalGuaranteeFollowUp,
    IApplicationStatus.CardAccountSetupComplete,
    IApplicationStatus.Referred,
    IApplicationStatus.CallbackRequested
  ])
};
